export const ZOOM_TOGEOM = 'zoom_togeom'
export const ZOOM_TOEXTENT = 'zoom_toextent'
export const OPEN_TNT = 'open-tnt'
export const OPEN_LTE = 'open-lte'
export const EVENT_USER_INFO = 'event_user_info'
